import { createBrowserRouter } from 'react-router';
import { RootLayout } from '@/layouts/RootLayout';
import {
  GuestRoute,
  AdminLayout,
  DoctorLayout,
} from '@/components/ProtectedRoute';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DoctorDashboard } from '@/pages/doctor/DoctorDashboard';
import { AssignmentDetail } from '@/pages/doctor/AssignmentDetail';
import { PatchAnnotator } from '@/pages/doctor/PatchAnnotator';
import { AdminDashboard } from '@/pages/admin/AdminDashboard';
import { CreateDoctor } from '@/pages/admin/CreateDoctor';
import { UploadPage } from '@/pages/admin/UploadPage';
import { SampleDetail } from '@/pages/admin/SampleDetail';
import { AdminReviewPage } from '@/pages/admin/AdminReviewPage';
import { ComparisonViewer } from '@/pages/admin/ComparisonViewer';
import { EditDoctor } from '@/pages/admin/EditDoctor';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      {
        Component: GuestRoute,
        children: [{ index: true, Component: LoginPage }],
      },
      {
        Component: AdminLayout,
        children: [
          { path: 'admin', Component: AdminDashboard },
          { path: 'admin/upload', Component: UploadPage },
          { path: 'admin/samples/:sampleId', Component: SampleDetail },
          { path: 'admin/samples/:sampleId/reviews/:assignmentId', Component: AdminReviewPage },
          { path: 'admin/samples/:sampleId/reviews/:assignmentId/patches/:patchId', Component: PatchAnnotator },
          { path: 'admin/samples/:sampleId/comparison/patches/:patchId', Component: ComparisonViewer },
          { path: 'admin/doctors/new', Component: CreateDoctor },
          { path: 'admin/doctors/:doctorId/edit', Component: EditDoctor },
        ],
      },
      {
        Component: DoctorLayout,
        children: [
          { path: 'doctor', Component: DoctorDashboard },
          { path: 'doctor/assignments/:assignmentId', Component: AssignmentDetail },
          { path: 'doctor/assignments/:assignmentId/patches/:patchId', Component: PatchAnnotator },
          { path: 'doctor/assignments/:assignmentId/comparison/patches/:patchId', Component: ComparisonViewer },
        ],
      },
    ],
  },
]);
